import { Layout as BaseLayout } from "antd";
import { FC, Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
// import PublicHeader from './PublicHeader';
import Sider from "antd/es/layout/Sider";
import { Content } from "antd/es/layout/layout";
// import loginImage from '../assets/images/authorization/login_image.png';
// import loginImageThmb from '../assets/images/authorization/login_image_thumbnail.png';

const PublicLayout: FC = () => {
  const [imgLoaded, setImgLoaded] = useState<boolean>(false);

  const handleLoading = () => {
    setImgLoaded(true);
  };

  return (
    <BaseLayout className="app">
      <BaseLayout className="publicContent">
        {/*<Sider className="authSidebar">*/}
        {/*  /!* <img*/}
        {/*    src={loginImage}*/}
        {/*    alt="background"*/}
        {/*    loading="lazy"*/}
        {/*    onLoad={handleLoading}*/}
        {/*  />*/}
        {/*  <img*/}
        {/*    className="authSidebar__smallImg"*/}
        {/*    src={loginImageThmb}*/}
        {/*    alt="background"*/}
        {/*    style={{ display: imgLoaded ? 'none' : 'block' }}*/}
        {/*  /> *!/*/}
        {/*</Sider>*/}
        <BaseLayout className="center">
          {/* <PublicHeader /> */}
          <Content>
            <Suspense>
              <Outlet />
            </Suspense>
          </Content>
        </BaseLayout>
      </BaseLayout>
    </BaseLayout>
  );
};

export default PublicLayout;
